import { filesize } from 'filesize';

export const convertFileSize = (size: number) => {
    return filesize(size, { round: 1, standard: 'jedec' }).toString();
};

export const getFileExtension = (filename: string) => {
    return filename.split('.').pop();
};

export const getFileExtensionFromUrl = (url?: string) => {
    if (!url) return '';

    try {
        const pathname = new URL(url, window.location.href).pathname;
        return pathname.match(/\.([^./]+)$/)?.[1].toLowerCase() ?? '';
    } catch {
        return '';
    }
};
